// =CALENDAR CAROUSEL
// ---------------------------------------------------------------------------
// Adapted from: https://medium.com/@magyarn/simple-carousel-with-vanilla-js-3dd10a143ff2
window.scrollBy(0,1); // SAFARI FIX

// calculate upon load, not before
window.addEventListener("load", function () {
    // console.log("screen width", window.innerWidth);
    // console.log("avail screen width", window.screen.availWidth);
    const carousel = document.querySelector('.calendar-carousel');

    if(carousel) {
        const carouselItem = carousel.querySelector('.carousel-item');
        const arrowBack = document.querySelector('.arrow-back');
        const arrowNext = document.querySelector('.arrow-next');

        const carouselWidth = carousel.offsetWidth;
        // console.log(carouselWidth);
        const carouselItemCount = carousel.querySelectorAll('.carousel-item').length;
        // console.log(carouselItemCount);
        const carouselItemWidth = carouselItem.offsetWidth;
        // console.log(carouselItemWidth);

        const cardStyle = carouselItem.currentStyle || window.getComputedStyle(carouselItem);
        const cardMarginRight = Number(cardStyle.marginRight.match(/\d+/g)[0]);
        // console.log(cardMarginRight);

        let increment = 0;
        if (window.innerWidth < 500) {
            increment = 1;
        }
        if (window.innerWidth > 500) {
            increment = 2;
        }
        if (window.innerWidth >= 768) {
            increment = 3;
        }
        if (window.innerWidth >= 1280) {
            increment = 4;
        }

        // console.log("increment", increment);
        const carouselScrollWidth = carouselItemWidth * increment; // page
        const totalWidth = carouselItemWidth * carouselItemCount;
        const pages = Math.floor(totalWidth / carouselScrollWidth);
        // console.log(carouselScrollWidth, totalWidth, pages);

        let offset = 0;
        let page = 0;
        
        // const maxX = -((carouselItemCount / 3) * carouselWidth +
        //                 (cardMarginRight * (carouselItemCount / 3)) -
        //                 carouselWidth - cardMarginRight);
        
        const maxX = -(carouselItemCount * carouselItemWidth);

        // console.log(maxX);

        if( offset == 0) {
            arrowBack.classList.add('js__disable');
        }

        arrowBack.addEventListener('click', function(){
            if (page != 0) {
                arrowBack.classList.remove('js__disable');
                offset += carouselScrollWidth;
                page--;
                // console.log(offset);
                // console.log(page);
                // carousel.style.transform = `translateX(${offset}px)`; // does not work in IE11
                carousel.style.transform = "translateX(" + offset + "px)";
            }

            if(page < pages){
                arrowNext.classList.remove('js__disable');   
            }

            if(page == 0) {
                arrowBack.classList.add('js__disable');
            }

            
        });

        arrowNext.addEventListener('click', function(){
            // if (parseFloat(offset) > parseFloat(maxX)) {
            if (page < pages) {
                arrowNext.classList.remove('js__disable');
                offset -= carouselScrollWidth;
                page++;
                // console.log(offset);
                // console.log(maxX);
                // console.log(page);
                // carousel.style.transform = `translateX(${offset}px)`; // does not work in IE11
                carousel.style.transform = "translateX(" + offset + "px)";
            }
            if (page == pages) {
                arrowNext.classList.add('js__disable');   
            }

            if( offset == 0) {
                arrowBack.classList.add('js__disable');
            } else {
                arrowBack.classList.remove('js__disable');   
            }
        });

    }

    const carouselLS = document.querySelector('.livestream-carousel');
    if(carouselLS) {

        const sliderControl = document.querySelector('.livestream-carousel__wrapper .slider-controls');
        const carouselItem = carouselLS.querySelector('.carousel-item');
        const arrowBack = document.querySelector('.livestream-carousel__wrapper .arrow-back');
        const arrowNext = document.querySelector('.livestream-carousel__wrapper .arrow-next');
            
        // console.log(arrowBack);
        const carouselWidth = carouselLS.offsetWidth;
        // console.log(carouselWidth);
        const carouselItemCount = carouselLS.querySelectorAll('.carousel-item').length;
        // console.log(carouselItemCount);
        const carouselItemWidth = carouselItem.offsetWidth;
        // console.log(carouselItemWidth);

        const cardStyle = carouselItem.currentStyle || window.getComputedStyle(carouselItem);
        const cardMarginRight = Number(cardStyle.marginRight.match(/\d+/g)[0]);
        // console.log(cardMarginRight);

        let increment = 0;
        if (window.innerWidth < 640) {
            increment = 1;
        }
        if (window.innerWidth > 640) {
            increment = 2;
        }
        if (window.innerWidth >= 940) {
            increment = 3;
        }
        if (window.innerWidth >= 1230) {
            increment = 4;
        }

        // console.log("increment", increment);
        const carouselScrollWidth = carouselItemWidth * increment; // page
        const totalWidth = carouselItemWidth * (carouselItemCount - 1);
        const pages = Math.floor(totalWidth / carouselScrollWidth);
        // console.log(carouselScrollWidth, totalWidth, pages);

        let offset = 0;
        let page = 0;
        
        // const maxX = -((carouselItemCount / 3) * carouselWidth +
        //                 (cardMarginRight * (carouselItemCount / 3)) -
        //                 carouselWidth - cardMarginRight);
        
        const maxX = -((carouselItemCount - 1) * carouselItemWidth);

        // console.log(maxX);

    
        if( offset == 0) {
            arrowBack.classList.add('js__disable');
        }

        arrowBack.addEventListener('click', function(){
            if (page != 0) {
                arrowBack.classList.remove('js__disable');
                offset += carouselScrollWidth;
                page--;
                // console.log(offset);
                // console.log(page);
                // carouselLS.style.transform = `translateX(${offset}px)`; // does not work in IE11
                carouselLS.style.transform = "translateX(" + offset + "px)";
            }

            if(page < pages){
                arrowNext.classList.remove('js__disable');   
            }

            if(page == 0) {
                arrowBack.classList.add('js__disable');
            }

            console.log(page, "back");
            console.log(pages, "back");
        });

        arrowNext.addEventListener('click', function(){
            // if (parseFloat(offset) > parseFloat(maxX)) {
            if (page < pages) {
                arrowNext.classList.remove('js__disable');
                offset -= carouselScrollWidth;
                page++;
                // console.log(offset);
                // console.log(maxX);
                // console.log(page);
                // carouselLS.style.transform = `translateX(${offset}px)`; // does not work in IE11
                carouselLS.style.transform = "translateX(" + offset + "px)";

                // if((page + 1) == pages && carouselItemCount%2 == 0) {
                //     arrowNext.classList.add('js__disable');
                // }
            }
            
            if (page == pages) {
                arrowNext.classList.add('js__disable');
            }

            if( offset == 0) {
                arrowBack.classList.add('js__disable');
            } else {
                arrowBack.classList.remove('js__disable');   
            }

            console.log(page, "next");
            console.log(pages, "next");
            console.log(carouselItemCount);
        });

        // if less than 5 live streaming events
        if (carouselItemCount < 5){
            let increment = 1;
            function livestreamLess() {
                if (window.innerWidth > 1152) {
                    sliderControl.classList.add('is-hidden');
                    offset = 0;
                    page = 0;
                    // carouselLS.style.transform = `translateX(${offset}px)`; // does not work in IE11
                    carouselLS.style.transform = "translateX(" + offset + "px)";
                    arrowBack.classList.add('js__disable');
                    arrowNext.classList.remove('js__disable');   
                } else {
                    sliderControl.classList.remove('is-hidden');
                }
            }
            livestreamLess();
        

            function resizeWindow() {
                livestreamLess();
            }
            window.addEventListener('resize', resizeWindow);

        }
        

    }
}); // END LOAD